import { create } from 'zustand';
import { Product, ScanHistoryItem } from './types';

interface StoreState {
  scanHistory: ScanHistoryItem[];
  addToHistory: (product: Product) => void;
  clearHistory: () => void;
  setScanHistory: (history: ScanHistoryItem[]) => void;
}

export const useStore = create<StoreState>((set) => ({
  scanHistory: [],

  addToHistory: (product: Product) => {
    const historyItem = {
      product,
      scannedAt: new Date(),
    };

    set((state) => ({
      scanHistory: [historyItem, ...state.scanHistory].slice(0, 50),
    }));
  },

  clearHistory: () => set({ scanHistory: [] }),
  
  setScanHistory: (history: ScanHistoryItem[]) => set({ scanHistory: history }),
}));